export function getView(is_new_appointment_overlay_enabled) {
  return is_new_appointment_overlay_enabled ? 'New' : 'Old'
}
